export default "__VITE_ASSET__BtG4rbAR__"